import './CreateRequestWithdraw.scss';
import { InputSelect, InputText, InputNumber } from 'components';
import { Button, InputWraper, useForm } from 'modules';
import React from 'react';
import * as Yup from 'yup';
import { components } from 'react-select';
import { toast } from 'react-hot-toast';
import { useGetAccountBanksQuery } from 'services/recipientBankAccount';
import { useCreateRequestWithdrawMutation } from 'services';
import { useGetUserProfileQuery } from 'services';
import { Icon } from 'components/icon';

const componentsElement = components as any;

const CustomOption = (props: any) => (
  <componentsElement.Option {...props}>
    <div className='create-request-withdraw__bank-option'>
      <div className='create-request-withdraw__bank-option-main'>
        <img src={props.data.logo} alt='' className='image-bank' />
        <span>{props.data.label}</span>
      </div>
      {props.data.isLegacy && (
        <span className='create-request-withdraw__legacy-badge'>
          <Icon.Warning size={14} />
          Không còn hỗ trợ
        </span>
      )}
    </div>
  </componentsElement.Option>
);

const CustomSingleValue = (props: any) => (
  <componentsElement.SingleValue {...props}>
    <div className='create-request-withdraw__bank-value'>
      <img loading='lazy' src={props.data.logo} alt='' className='image-bank' />
      <span>{props.data.label}</span>
      {props.data.isLegacy && (
        <span className='create-request-withdraw__legacy-badge'>
          <Icon.Warning size={14} />
          Không còn hỗ trợ
        </span>
      )}
    </div>
  </componentsElement.SingleValue>
);

const CustomControl = (props: any) => (
  <componentsElement.Control {...props}>
    <div style={{ padding: 5, width: '100%', height: '100%', display: 'flex' }}>
      {props.children}
    </div>
  </componentsElement.Control>
);

const CustomMenu = (props: any) => (
  <componentsElement.Menu {...props}>
    <div
      style={{
        borderRadius: 4,
        width: '100%',
        height: '100%',
        display: 'flex',
      }}
    >
      {props.children}
    </div>
  </componentsElement.Menu>
);

const CreateRequestWithdraw = () => {
  const { mutateAsync } = useCreateRequestWithdrawMutation();
  const { data: listBanks } = useGetAccountBanksQuery();
  const { data } = useGetUserProfileQuery();

  const {
    handleSubmit,
    getInputProps,
    resetForm,
    setValues,
    getValue,
    isSubmitting,
  } = useForm({
    structure: [
      {
        name: 'amount',
        label: 'Số điểm',
        validate: Yup.string().required('Vui lòng nhập số điểm'),
        defaultValue: 0,
      },
      {
        name: 'fullName',
        label: 'Tên tài khoản',
        validate: Yup.string().required('Vui lòng nhập tên tài khoản'),
        defaultValue: data?.fullName,
        isDisabled: true,
      },
      {
        name: 'bankAccountId',
        label: 'Tài khoản ngân hàng',
        validate: Yup.string().required('Vui lòng chọn Ngân hàng'),
      },
    ],
    onSubmit: async (values) => {
      const selectedBankAccount = listBanks?.data?.find(
        (item) => String(item.id) === String(values.bankAccountId),
      );

      if (selectedBankAccount?.isLegacy) {
        toast.error(
          'Ngân hàng này không còn hỗ trợ. Vui lòng chọn tài khoản ngân hàng khác',
        );
        return;
      }

      const normalizedValues = {
        bankAccountId: values.bankAccountId,
        amount: values.amount,
      };
      try {
        await mutateAsync(normalizedValues);
        toast.success('Tạo Yêu cầu rút điểm thành công', { duration: 1500 });
        resetForm();
      } catch (error) {
        console.log('error', error);
      }
    },
  });

  const selectedBankAccount = listBanks?.data?.find(
    (item) => String(item.id) === String(getValue('bankAccountId')),
  );

  const handleCreateRequest = () => {
    if (selectedBankAccount?.isLegacy) {
      toast.error(
        'Ngân hàng này không còn hỗ trợ. Vui lòng chọn tài khoản ngân hàng khác',
      );
      return;
    }

    handleSubmit();
  };

  const getSecretBank = (value: string) => {
    if (value.length <= 10) {
      return value.slice(0, 2) + '****' + value.slice(-2);
    } else {
      return value.slice(0, 4) + '****' + value.slice(-4);
    }
  };

  return (
    <div className='create-request-withdraw'>
      <div className='row container-fluid-request-withdraw'>
        <h1>Tạo yêu cầu rút điểm</h1>
        <InputWraper
          className='col-lg-12'
          inputProps={getInputProps('amount')}
          component={InputNumber}
        />
        <InputWraper
          className='col-lg-12'
          inputProps={getInputProps('fullName')}
          component={InputText}
        />
        <InputWraper
          className='col-lg-12'
          inputProps={getInputProps('bankAccountId')}
          renderInput={(props) => (
            <InputSelect
              {...props}
              onChange={(e) => {
                setValues({ bankAccountId: e });
                props.onChange(e);
              }}
              options={listBanks?.data?.map((item) => ({
                label:
                  item.bank.shortName +
                  ' - ' +
                  item.bank.name +
                  ' - ' +
                  getSecretBank(item.accountNumber),
                value: item.id,
                logo: item.bank.logo,
                isLegacy: item.isLegacy,
              }))}
              components={{
                Menu: CustomMenu,
                Control: CustomControl,
                SingleValue: CustomSingleValue,
                Option: CustomOption,
              }}
            />
          )}
        />
        {selectedBankAccount?.isLegacy && (
          <div className='create-request-withdraw__legacy-warning' role='alert'>
            <Icon.Warning size={18} />
            <span>
              Ngân hàng không còn hỗ trợ. Không thể tạo yêu cầu rút điểm bằng
              tài khoản này.
            </span>
          </div>
        )}
      </div>

      <p className='text-danger'>
        * Chúng tôi không chịu trách nhiệm cho việc điền sai thông tin nhận tiền
        hoặc bị hack tài khoản
      </p>
      <div className='wrap-button-create-user'>
        <Button
          label='Gửi yêu cầu'
          type='submit'
          onClick={handleCreateRequest}
          buttonType='success'
          className='create-request-withdraw__submit'
          disabled={!!selectedBankAccount?.isLegacy || isSubmitting}
          isLoading={isSubmitting}
        />
      </div>
    </div>
  );
};

export default CreateRequestWithdraw;
